import React from "react";
import { Link } from "react-router-dom";
import "./styles/logo.css";

const Logo = ({ width, link = true }) => {
	const imageElement = (
		<img
			src="logo.png"
			alt="logo"
			style={{ width: width }}
		/>
	);

	return (
		<>
			{link ? (
				<Link to="/" style={{ display: "flex" }}>
					{imageElement}
				</Link>
			) : (
				imageElement
			)}
		</>
	);
};

export default Logo;
